import React from 'react';
import { SquareLoader } from 'components/shared/ui-components/loader';

const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw'
  }}>
    <SquareLoader label="Loading..." />
  </div>
);

export default LoadingSpinner;
